import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { classnames, ClickClose, Icon } from "@culturehq/components";

import { useProfile } from "app/context";
import { useDoor } from "app/hooks";
import { Trans } from "app/utils";

import NotificationItem from "components/notifications/NotificationItem";

const PointsTrophy = ({ onClose, onOpen, seenNotifications, unseenNotifications, unseen }) => {
  const { profile } = useProfile();
  const { open, onClose: onDoorClose, onOpen: onDoorOpen } = useDoor(false);

  const onClickClose = useCallback(
    () => {
      if (open) {
        onDoorClose();
        onClose();
      }
    },
    [open, onDoorClose, onClose]
  );

  const onToggle = useCallback(
    () => {
      if (open) {
        onDoorClose();
        onClose();
      } else {
        onDoorOpen();
        onOpen();
      }
    },
    [open, onDoorClose, onClose, onDoorOpen, onOpen]
  );

  return (
    <ClickClose className="chq-nav--noti" onClose={onClickClose}>
      <div className="chq-nav--notit" onClick={onToggle}>
        <Icon icon="trophy" />
        {unseen > 0 && <em>{unseen}</em>}
      </div>
      <ul
        className={
          classnames("chq-nav--drop", "chq-nav--drop-points", { "chq-nav--drop-open": open })
        }
      >
        <li>
          <Link to="/profile/achievements">
            <Trans>My Community Score</Trans>{" "}
            <span className="chq-nav--drop-points--points">{profile.points}</span>
          </Link>
        </li>
        <li>
          <div className="notification-drawer__notifications no-scrollbar">
            {unseenNotifications.length > 0 && <h2>New</h2>}
            {unseenNotifications.map(notification => (
              <NotificationItem key={notification.id} notification={notification} />
            ))}
            {seenNotifications.length > 0 && <h2>Seen</h2>}
            {seenNotifications.map(notification => (
              <NotificationItem key={notification.id} notification={notification} />
            ))}
          </div>
        </li>
        <div className="chq-nav--dropf">
          <Link to="/profile/achievements" onClick={onClickClose}>
            <Trans>View all</Trans>
          </Link>
          {" "}
          ·
          {" "}
          <Link to="/score" onClick={onClickClose}>
            <Trans>Learn more</Trans>
          </Link>
        </div>
      </ul>
    </ClickClose>
  );
};

export default PointsTrophy;
